import { axiosGet, axiosPost } from '../axios/httpRequest';

/**
 * 更新用户须知
 */
export const postUserNoticeApi = params => {
    return axiosPost('api/user_notice/v1/content', params);
};

/**
 * 获取用户须知内容
 */
export const getUserNoticeApi = params => {
    return axiosGet(`api/user_notice/v1/content`, params);
};

/**
 *
 * 获取内容详情
 */
export const getUserNoticeByIdApi = params => {
    return axiosGet(`api/user_notice/v1/content/${params.id}`, params);
};

/**
 * 更新文本内容
 */
export const postUserNoticeByIdApi = params => {
    return axiosPost('api/user_notice/v1/contentById', params);
};

export const getUserNoticeByIdApiV2 = params => {
    return axiosGet('api/user_notice/v2/content/{id}', params);
};

/**
 * 获取内容列表
 */
export const getContentListApi = params => {
    return axiosGet('api/user_notice/v1/contentList', params);
};
